import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEnergyTrxHistoryApi } from "store/actions";
import Table from "components/Table";
import Columns from "./Columns";
import FormikForm from "components/shared/FormikForm";

const InputFieldsForSearch = [
  {
    name: "search",
    type: "text",
    label: "",
    placeholder: "Search...",
  }
];
const initialValuesForFilter = {
  search: "",
};

const List = ({ userDetails }) => {
  const dispatch = useDispatch();
  const { energyPurchaseHistory, loading, totalPurchaseCount } = useSelector(({ EnergyPackage }) => EnergyPackage);
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    order: -1,
    orderBy: "date_created_utc",
    search: "",
    status: "",
    userId: userDetails?._id
  });

  useEffect(() => {
    if (userDetails?._id) {
      getApiData({ ...filter, userId: userDetails?._id });
      setcolumns(Columns({ }));
    }
  }, [filter, userDetails]);

  async function getApiData(query) {
    try {
      dispatch(getEnergyTrxHistoryApi({ data: query }));
    } catch (error) { }
  }

  const handleFilterForm = (info) => {
    setFilter({
      ...filter,
      page: 1,
      limit: 10,
      order: -1,
      orderBy: "date_created_utc",
      search: info.search,
      status: info.status,
    });
  };


  return (
    <>
      <div className="section-body">
        <div className="card">
          <div className="row justify-content-between">
            <div className="col-12">
              <div className="card-header">
                <FormikForm
                  initialValues={initialValuesForFilter}
                  onSubmit={handleFilterForm}
                  loading={loading}
                  inputFields={InputFieldsForSearch}
                  buttonText={"Search"}
                />
              </div>
            </div>

          </div>
        </div>
        {energyPurchaseHistory?.length > 0 && (
          <Table
            data={energyPurchaseHistory}
            columns={columns}
            setFilter={setFilter}
            total={totalPurchaseCount}
            filter={filter}
          />
        )}
        {!loading && energyPurchaseHistory?.length === 0 && (
          <p style={{ textAlign: "center" }}>No Data Found</p>
        )}
      </div>
    </>
  );
};

export default List;
